import { PortalDocuments } from "@/features/portal/components/documents/portal-documents";

/** `/portal/documents` — documents the firm published to this client. */
export default function DocumentsPage() {
  return <PortalDocuments />;
}
